import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export const PaymentCancel = () => {
  return (
    <div data-testid="payment-cancel-page" className="relative z-[2] min-h-screen grid place-items-center px-6 py-24">
      <div className="w-full max-w-lg border border-white/10 bg-[#0f0f11] p-8 text-center rounded-lg">
        <XCircle size={40} className="text-[#8b8b93] mx-auto mb-6" />
        <h1 className="font-display font-bold text-2xl">Zahlung abgebrochen</h1>
        <p className="mt-2 text-[#8b8b93] text-sm">
          Kein Problem – es wurde nichts berechnet. Dein OG Pack wartet weiterhin im Tresor auf dich.
        </p>
        <Link
          data-testid="cancel-home"
          to="/"
          className="mt-6 inline-block bg-[#e2ff00] text-black font-mono text-sm uppercase tracking-[0.2em] px-6 py-3 rounded-full hover:bg-white transition-colors"
        >
          Zurück zum Shop
        </Link>
      </div>
    </div>
  );
};
